import React, { useState, useContext, useEffect } from "react";

// MUI
import Box from '@mui/material/Box';

//Custom Components
import AppPage from "@/ui/AppPage/AppPage";
import KomunalneObvezeTable from "./KomunalneObvezeTable"
import OperationsContext, { OperationsContextType } from "@/components/OperationsContext/OperationsContext";
import DialogContext from "@/ui/DialogContext/DialogContext";
import LoaderContext from "@/components/LoaderContext/LoaderContext";
import dataController from "@/lib/dataController";
import KomunalneObvezeDialog from "./KomunalneObvezeDialog"
import XMLDialog from "./XMLDialog";

import model from "@/models/komunalne_obveze";
import { Permissions } from "@/lib/permissions";

// Types
import { DialogContextType } from "@/@types/ui/DialogContext";
import { LoaderContextType } from "@/@types/context/LoaderContext";
import { DCRecord, IDataController } from "@/@types/lib/dataController"
import api from "@/lib/api";

function KomunalneObvezePage() {
  const operationsContext = useContext(OperationsContext) as OperationsContextType;
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;
  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);

  const selectedProject = operationsContext.selectedProject

  // FUNCTIONS
  // -------------------------------------------------------------------------------------------

  function handleOpenExportDialog(selection: string[]) {
    const selectedRecords = records.filter((record, i) => selection.includes(i.toString()))
    const selectedRecordsIds = selectedRecords.map((record) => record.id)

    dialogContext.showDialog(KomunalneObvezeDialog, {
      dc: dc,
      form: "zapisnici",
      mode: "insert",
      onClose: handleDialogClose,
      defaultValues: {
        export_mode: "old",
        selected_records: selectedRecordsIds,
        dof: "ENA:014_DOF",
        link_tables: "db.v_objekti_upitnik, db.v_novo_stanje, db.v_postojece_stanje",
        // link_tables: "db.v_details_obj_plain,db.v_objekti_upitnik,db.novo_stanje,db.postojece_stanje",
        link_aggregates: "db.v_details_obj_plain:s:sum,db.v_details_obj_plain:s:sum,db.v_details_obj_plain:p:sum,db.v_details_obj_plain:k:sum,db.v_details_obj_plain:g:sum,db.v_details_obj_plain:j:sum,db.v_details_obj_plain:t:sum,db.v_details_obj_plain:bazen:sum,db.v_details_obj_plain:b:sum,db.v_details_obj_plain:b2:sum,db.v_details_obj_plain:o:sum,db.v_details_obj_plain:f:sum,db.v_details_obj_plain:n:sum,db.v_details_obj_plain:ukupno:sum"
      }
    })

  }

  function exportData(record: DCRecord) {
    if (!selectedProject || !selectedProject.id) {
      return
    }

    const apiInstance = new api();

    const url = `operations/projekti/${selectedProject.id}/komunalne-obveze-zap`
    loaderContext.toggleLoading(true);
    apiInstance.GetXML(url, 'post', record)
      .then((resp) => {
        if (resp.success && resp.data) {
          // console.log(resp.data);
          if (Object.keys(resp.data).indexOf('xml') != -1) {
            //@ts-ignore
            const xml = resp.data['xml'];
            dialogContext.showDialog(XMLDialog, {
              dc: dc,
              form: "xml",
              mode: "view",
              onClose: handleXMLDialogClose,
              defaultValues: {
                xml: xml}
            })
          }
        }
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      })

  }

  const handleDialogClose = (result: { dataChanged: boolean; action: string }, record: DCRecord | null) => {
    if (result.dataChanged && record) {
      exportData(record)
    }

    dialogContext.hideDialog()
  };

  const handleXMLDialogClose = () => {
    dialogContext.hideDialog();
  }

  const refreshRecords = () => {
    if (!selectedProject) {
      setRecords([]);
      return
    }

    const url = `operations/projekti/${selectedProject.id}/komunalne-obveze`
    dc.GetData(url).then((resp) => {
      if (resp.success) {
        setRecords(resp.data as Array<DCRecord>)
      };
    });
  };

  // EFFECTS
  // -------------------------------------------------------------------------------------------

  useEffect(() => {
    refreshRecords();
  }, [selectedProject]);

  // RETURN
  // -------------------------------------------------------------------------------------------
  return (
    <AppPage needPermission={[Permissions.Administration]}>
      <Box m={0} style={{ height: "100%" }}>
        <KomunalneObvezeTable
          dc={dc}
          records={records}
          handleOpenExportDialog={handleOpenExportDialog}
          selectedProject={selectedProject}
        />
      </Box>
    </AppPage>
  )
}

export default KomunalneObvezePage